/**
 * Checks if an element is detached (i.e. not in the current document)
 */
export var isDetachedElement = function isDetachedElement(el) {
  return !document.body.contains(el);
};